import React, { PureComponent } from "react";
import { Container, Row, Col } from "reactstrap";
import Players from "./players";
import { connect } from "react-redux";
import { withSocket } from "../../socket/context";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import VerbodenTimer from "../verbodenTimer";
import { AnimatePresence } from "framer-motion";

class VerbodenGameLayout extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { children, users, gameReducer } = this.props;
    let roomData = gameReducer.roomObj;
    let activeTeamA = false;
    let activeTeamB = false;
    let gameStatus =
      roomData && roomData.game_state && roomData.game_state.status
        ? roomData.game_state.status
        : "";
    if (roomData && roomData.game_state && roomData.game_state.current_team) {
      roomData.game_state.current_team === "A"
        ? (activeTeamA = true)
        : (activeTeamB = true);
    }
    let teams = [];
    let team1PlayerIds = [];
    let team1Data = {};
    let team2Data = {};
    let team2PlayerIds = [];
    let team1Score = 0,
      team2Score = 0;
    const gS = roomData && roomData.game_state;
    const current_round = gS.current_round || null;
    if (gS && gS.teams && gS.teams.length > 0) {
      teams = gS.teams;
      if (gS.teams[0]) {
        team1Data = gS.teams[0];
        team1PlayerIds = gS.teams[0].team_queue;
        team1PlayerIds = gS.teams[0].team_queue;
        // team1Score =
        //   Number(gS.right_words_a.length) - Number(gS.skipped_words_a.length);
        // team1Score = team1Score < 0 ? 0 : team1Score;
      }
      if (gS.teams[1]) {
        team2Data = gS.teams[1];
        team2PlayerIds = gS.teams[1].team_queue;
        // team2Score =
        //   Number(gS.right_words_b.length) - Number(gS.skipped_words_b.length);
        // team2Score = team2Score < 0 ? 0 : team2Score;
      }
    }
    let teamAText = "Team A";
    let teamBText = "Team B";
    if (this.props.paramsReducer && this.props.paramsReducer.gameObj) {
      let gameObj = this.props.paramsReducer.gameObj;

      if (gameObj && gameObj.screens && gameObj.screens.vb) {
        teamAText = gameObj.screens.vb.teams_label_a;
        teamBText = gameObj.screens.vb.teams_label_b;
      }
    }
    const roomUsers = roomData.users;
    return (
      <Container fluid>
        <Row className="m-xxxl-3 vb-layout-row  my-3 p-1">
          <Col sm={3} className="palyerCol">
            <AnimatePresence exitBeforeEnter>
              <Players
                key="vb_left_players"
                teamName={teamAText}
                socket={this.props.socket}
                roomData={roomData}
                players={team1PlayerIds}
                teamData={team1Data}
                roomUsers={roomUsers}
                teamScore={team1Score}
                activeTeam={activeTeamA}
                gameStatus={gameStatus}
                current_round={current_round}
                type="teamA"
              />
            </AnimatePresence>
          </Col>
          <Col sm={6} className="childCol">
            <AnimatePresence exitBeforeEnter>{children}</AnimatePresence>
          </Col>
          <Col sm={3} className="palyerCol">
            <AnimatePresence exitBeforeEnter>
              <Players
                key="vb_right_players"
                teamName={teamBText}
                socket={this.props.socket}
                roomData={roomData}
                players={team2PlayerIds}
                teamData={team2Data}
                roomUsers={roomUsers}
                teamScore={team2Score}
                activeTeam={activeTeamB}
                gameStatus={gameStatus}
                current_round={current_round}
                type="teamB"
              />
            </AnimatePresence>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer
});

export default connect(mapStateToProps, null)(VerbodenGameLayout);
